import React from 'react';

/**
 * Policy number template with fallback
 */
export const PolicyNumberTemplate: React.FC<{ number?: string | null }> = ({ number }) => {
  return <span>{number || '-'}</span>;
};

export default PolicyNumberTemplate;
